import wangsanavyahouse1 from "./wangsa-navya-house.png";
import wangsanavyahouse2 from "./wangsa-navya-house (2).png";
import wangsanavyahouse3 from "./wangsa-navya-house (3).png";
import wangsanavyahouse4 from "./wangsa-navya-house (4).png";
import wangsanavyahouse5 from "./wangsa-navya-house (5).png";
import wangsanavyahouse6 from "./wangsa-navya-house (6).png";
import wangsanavyahouse7 from "./wangsa-navya-house (7).png";


const wangsanavyahouse = [
  wangsanavyahouse1,
  wangsanavyahouse2,
  wangsanavyahouse3,
  wangsanavyahouse4,
  wangsanavyahouse5,
  wangsanavyahouse6,
  wangsanavyahouse7,
];

export default wangsanavyahouse;

